const React = require('react');
const c = require('./module.scss');

class Path extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let len = this.props.path.length;
        if (!len) {
            return null;
        }
        let view = this.props.path.map(function(o, i) {
            if (o) {
                if ((len - 1) == i) {
                    return <span className='fp-path-cur fp-path-text'>
                        {o.name}
                    </span>;
                } else {
                    return <a href={o.url} className='fp-path-link'>
                        <span className='fp-path-text'>{o.name}</span>
                        <i className='fp-path-icon'></i>
                    </a>;
                }
            }
        });
        return <div className='fp-path'>
            {view}
            {
                this.props.isShowBack ? <span className='fp-back' onClick={function() {
                    window.history.go(-1);
                }}>返回上一页</span> : ''
            }
        </div>;
    }
}

module.exports = Path;



// WEBPACK FOOTER //
// ./component/frame/path.js